import { render, staticRenderFns } from "./MultiWhatsappChannelDetail.vue?vue&type=template&id=5257179b&scoped=true"
import script from "./MultiWhatsappChannelDetail.vue?vue&type=script&lang=js"
export * from "./MultiWhatsappChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./MultiWhatsappChannelDetail.vue?vue&type=style&index=0&id=5257179b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5257179b",
  null
  
)

export default component.exports